import { stringify } from 'qs';

const transform = (obj: Record<string, any>, property: string, func: (value: any) => string) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    if (key === property) {
      obj[key] = func(obj[key]);
    } else if (obj[key] instanceof Object) {
      transform(obj[key], property, func);
    }
  }
};

export const _serializer = (query: Record<string, any>) => {
  const obj = { ...query };

  transform(obj, '$regex', (value) => value.toString());

  return stringify(obj, {
    arrayFormat: 'indices',
    skipNulls: true,
  });
};
